import * as dcmjs from 'dcmjs';

/**
 * A simple wrapper class to wrap a dcm-js dataset in a strongly typed
 * object. Use this to pass reference to a dcm-js dataset and avoid
 * using eslint disable lines elsewhere in the code.
 */
export class DcmJsDatasetWrapper {
    public dataset: unknown;

    constructor(dataset: unknown) {
        this.dataset = dataset;
    }

    private static readonly _empty = new DcmJsDatasetWrapper(null);
    static empty(): DcmJsDatasetWrapper {
        return this._empty;
    }

    /// Convert the dataset to a blob of DICOM data.
    /// HACK: Uses a shallow clone to prevent dcmjs datasetToDict() from
    /// mutating the original dataset's _meta (it overwrites _meta
    /// in-place, flattening TransferSyntaxUID from {Value: [string]}
    /// to a plain string).
    public asBlob(): Blob {
        if (!this.dataset) {
            throw new Error('No dataset to convert to blob');
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const clone = { ...(this.dataset as any) };
        return new Blob([dcmjs.data.datasetToDict(clone).write()], {
            type: 'application/dicom',
        });
    }

    public setCharacterSet(characterSet: string): void {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this.dataset as any).SpecificCharacterSet = characterSet;
    }

    public get PatientID(): string {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (this.dataset as any)?.PatientID;
    }

    public get sopClassUID(): string {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (this.dataset as any)?.SOPClassUID;
    }

    public get seriesInstanceUID(): string | undefined {
        if (!this.dataset || typeof this.dataset !== 'object') {
            return undefined;
        }
        const uid = (this.dataset as { SeriesInstanceUID?: unknown })
            .SeriesInstanceUID;
        return typeof uid === 'string' ? uid : undefined;
    }
}
